
export default function Services() {
  const services = [
    {
      icon: 'ri-image-edit-line',
      title: 'YouTube Thumbnail Design',
      description: 'Specializing in attention-grabbing thumbnails optimized for clicks and performance.',
      gradient: 'from-purple-600 to-pink-600',
    },
    {
      icon: 'ri-palette-line',
      title: 'Branding Thumbnails',
      description: 'Cohesive and visually powerful thumbnail identity systems for creators.',
      gradient: 'from-cyan-500 to-blue-600',
    },
  ];

  return (
    <section className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
            My Quality Services
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Delivering exceptional thumbnail designs that drive engagement and grow your channel
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative p-8 bg-gradient-to-br from-purple-900/20 to-pink-900/20 rounded-3xl border border-purple-500/20 hover:border-purple-500/50 transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              {/* Glow effect */}
              <div className={`absolute inset-0 bg-gradient-to-r ${service.gradient} opacity-0 group-hover:opacity-10 rounded-3xl blur-xl transition-opacity duration-500`}></div>
              
              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-r ${service.gradient} rounded-2xl mb-6 shadow-lg group-hover:shadow-2xl transition-shadow duration-300`}>
                  <i className={`${service.icon} text-3xl`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-purple-300 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
